"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectNodeRemovedImpulse = void 0;
var EdgeKeyOne_1 = require("./EdgeKeyOne");
/**
 * Impulse which indicates the result removing a node connection
 */
var ConnectNodeRemovedImpulse = /** @class */ (function (_super) {
    __extends(ConnectNodeRemovedImpulse, _super);
    function ConnectNodeRemovedImpulse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "ConnectNodeRemovedImpulse";
        _this.id = function () {
            _this.push(function (_) { return "id"; });
        };
        /**
         * edges removed by this request
         */
        _this.removedEdges = function (config) { return _this.push(function (registry) {
            var entity = new EdgeKeyOne_1.EdgeKeyOne();
            config(entity);
            return "removedEdges { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return ConnectNodeRemovedImpulse;
}(Array));
exports.ConnectNodeRemovedImpulse = ConnectNodeRemovedImpulse;
//# sourceMappingURL=ConnectNodeRemovedImpulse.js.map